/**
 * Data colour.
 *
 * The chrome is monochrome; the DATA is not. Team and tyre colours are
 * information — you can tell a McLaren from a Ferrari at a glance, and
 * that is exactly the kind of glance this app exists to serve. So every
 * series takes the colour the backend attached to it and only falls back
 * to a fixed palette when a payload arrives without one.
 *
 * Fallback ordering is fixed rather than positional so the same driver
 * keeps the same colour between charts in one analysis run.
 */
export const FALLBACK = [
  '#ff3b30', // red
  '#ffd60a', // yellow
  '#0a84ff', // blue
  '#30d158', // green
  '#ff9f0a', // orange
  '#bf5af2', // purple
  '#64d2ff', // cyan
  '#ff375f', // pink
];

/** Colour for a series: the payload's own colour, else a stable fallback. */
export function seriesColor(item, index = 0) {
  const own = item && (item.color || item.stroke);
  if (own && typeof own === 'string' && own !== 'transparent') return own;
  return FALLBACK[((index % FALLBACK.length) + FALLBACK.length) % FALLBACK.length];
}

/**
 * Dash pattern, used only to break ties between two series that share a
 * colour (team-mates run the same hue). Colour leads; the dash is the
 * second channel, never the only one.
 */
export function seriesDash(index = 0) {
  const DASH = [undefined, '7 4'];
  return DASH[index % DASH.length];
}
